"use strict";

import {
	svc_fetchProductCatalog,
	svc_fetchCatalogItem,
	svc_createCatalogItem,
	svc_updateCatalogItem,
	svc_deleteCatalogItem,
	svc_bindCatalogItem,
	svc_unbindCatalogItem,
} from "@/services/productCatalog";
import { showServerResponse } from "@/utils/message";

const Model = {
	namespace: "m_ProductCatalog",

	state: {
		items: [],
		total: 0,
		currentItem: null,
	},

	reducers: {
		handleFetchAll(state, { payload }) {
			return {
				...state,
				items: payload.items || [],
				total: payload.total || 0,
			};
		},
		handleSetCurrentItem(state, { payload }) {
			return {
				...state,
				currentItem: payload,
			};
		},
	},

	effects: {
		*fetchAll({ payload }, { call, put }) {
			const response = yield call(svc_fetchProductCatalog, payload);
			if (!showServerResponse(response, true)) return;

			yield put({
				type: "handleFetchAll",
				payload: {
					items: response.result || [],
					total: response.count || 0,
				},
			});

			return response;
		},

		*fetchOne({ payload }, { call, put }) {
			const response = yield call(svc_fetchCatalogItem, payload.id);
			if (!showServerResponse(response, true)) return;

			const data = Array.isArray(response.result) ? response.result[0] : response.result;
			yield put({
				type: "handleSetCurrentItem",
				payload: data,
			});

			return response;
		},

		*createOne({ payload }, { call }) {
			const response = yield call(svc_createCatalogItem, payload);
			showServerResponse(response);
			return response;
		},

		*updateOne({ payload }, { call }) {
			const { id, ...data } = payload;
			const response = yield call(svc_updateCatalogItem, id, data);
			showServerResponse(response);
			return response;
		},

		*deleteOne({ payload }, { call }) {
			const response = yield call(svc_deleteCatalogItem, payload.id);
			showServerResponse(response);
			return response;
		},

		*bindOne({ payload }, { call }) {
			const response = yield call(svc_bindCatalogItem, payload);
			showServerResponse(response);
			return response;
		},

		*unbindOne({ payload }, { call }) {
			const response = yield call(svc_unbindCatalogItem, payload);
			showServerResponse(response);
			return response;
		},
	},

	subscriptions: {},
};

export default Model;
